import { useMemo } from 'react';
import { SharedScreenState } from '@/types/screen';

const DEFAULT_FONT_FAMILY = ['sans-serif'];

export function useStageStyles({ state }: { state: SharedScreenState }) {
  // Styles to apply to the root element
  const rootStyles = useMemo(() => {
    const headingFontFamily =
      state.draftTheme?.headingFontFamily ||
      state.savedTheme?.headingFontFamily ||
      DEFAULT_FONT_FAMILY;

    const bodyFontFamily =
      state.draftTheme?.bodyFontFamily ||
      state.savedTheme?.bodyFontFamily ||
      DEFAULT_FONT_FAMILY;

    const backgroundImageUrl =
      state.draftTheme?.stageBackgroundImage ||
      state.savedTheme?.stageBackgroundImage ||
      null;

    const backgroundColor =
      state.draftTheme?.backgroundColor ||
      state.savedTheme?.backgroundColor ||
      null;

    const foregroundColor =
      state.draftTheme?.foregroundColor ||
      state.savedTheme?.foregroundColor ||
      null;

    return {
      '--screen-heading-font-family': headingFontFamily.join(','),
      '--screen-body-font-family': bodyFontFamily.join(','),
      '--screen-foreground': foregroundColor ?? undefined,
      backgroundImage: backgroundImageUrl
        ? `url(${backgroundImageUrl})`
        : undefined,
      backgroundSize: 'cover',
      backgroundColor: backgroundColor ?? 'rgba(0,0,0,0.1)',
      '--screen-background': backgroundColor ?? 'rgba(0,0,0,0.1)',
    };
  }, [state]);

  return { rootStyles };
}
